const RESPONSE_PAYLOAD_START = /\{\s*"response"\s*:/;

const trimTrailingSeparators = (message: string): string => {
  return message.replace(/[\s:;,.-]+$/g, "").trim();
};

const extractMessageBeforeResponsePayload = (rawMessage: string): string | null => {
  const responsePayloadMatch = RESPONSE_PAYLOAD_START.exec(rawMessage);

  if (!responsePayloadMatch || responsePayloadMatch.index <= 0) {
    return null;
  }

  const messageBeforePayload = rawMessage.slice(0, responsePayloadMatch.index);
  const cleanedMessage = trimTrailingSeparators(messageBeforePayload);

  return cleanedMessage.length > 0 ? cleanedMessage : null;
};

const extractMessageFromResponsePayload = (rawMessage: string): string | null => {
  const responsePayloadMatch = RESPONSE_PAYLOAD_START.exec(rawMessage);

  if (!responsePayloadMatch) {
    return null;
  }

  const responsePayload = rawMessage.slice(responsePayloadMatch.index);

  try {
    const parsedPayload = JSON.parse(responsePayload) as {
      response?: { errors?: Array<{ message?: unknown }> };
    };

    const nestedMessage = parsedPayload.response?.errors?.[0]?.message;

    if (typeof nestedMessage !== "string") {
      return null;
    }

    return nestedMessage.trim();
  } catch {
    return null;
  }
};

const removeGraphQLErrorPrefix = (rawMessage: string): string => {
  return rawMessage.replace(/^GraphQL\s+error:\s*/i, "").trim();
};

const normalizeFormattedMessage = (rawMessage: string): string | undefined => {
  const formattedMessage = removeGraphQLErrorPrefix(rawMessage);

  return formattedMessage || undefined;
};

export const formatCheckoutErrorMessage = (errorMessage?: string): string | undefined => {
  if (!errorMessage) {
    return undefined;
  }

  const nestedPayloadMessage = extractMessageFromResponsePayload(errorMessage);

  if (nestedPayloadMessage) {
    return normalizeFormattedMessage(nestedPayloadMessage);
  }

  const messageBeforePayload = extractMessageBeforeResponsePayload(errorMessage);

  if (messageBeforePayload) {
    return normalizeFormattedMessage(messageBeforePayload);
  }

  return normalizeFormattedMessage(errorMessage);
};
